module.exports = __webpack_public_path__ + "img/ercode_hn.e46a5e7a.png";